import { render } from "./TemplateMyTicketsIndexOfPast.vue?vue&type=template&id=8ccaf168"
import script from "./TemplateMyTicketsIndexOfPast.vue?vue&type=script&lang=js"
export * from "./TemplateMyTicketsIndexOfPast.vue?vue&type=script&lang=js"
script.render = render

export default script